module.exports = __webpack_public_path__ + "static/media/03.ea779ca0.gif";